import React, { useEffect } from 'react';
import { Card, CardText, CardBody, CardTitle } from 'reactstrap';
import { emptyVips } from '../shared/emptyVips';
import { venusAPIUrl, vipsJSONLocation, tvlChangesJSONLocation } from '../shared/baseUrl';
import * as Abi from '../shared/Abi';
import * as chainAddreses from '../shared/chainAddresses';
import { allMarkets } from '../shared/tokens';
import * as helper_functions from '../services/helper_functions';
import Web3 from 'web3';

function RenderTVLCard({ tvlData, supplyChange, borrowChange }) {
    let totalSupply = 0;
    let totalBorrow = 0;
    let exchangeRateMantissa, totalSupplyMantissa, underlyingDecimal, supply, price, totalSupplyUsd, borrow, totalBorrowsUsd;
    tvlData.sort((a, b) => b.totalSupplyUsd - a.totalSupplyUsd);
    for (let currentToken of tvlData) {
        let symbol = currentToken.underlyingSymbol;
        if (symbol == null){
            continue;
        }
        exchangeRateMantissa = currentToken.exchangeRateMantissa;
        totalSupplyMantissa = currentToken.totalSupplyMantissa;
        underlyingDecimal = currentToken.underlyingDecimal;
        supply = totalSupplyMantissa * exchangeRateMantissa / 10 ** (18 + underlyingDecimal);
        price = currentToken.tokenPriceCents / 100;
        totalSupplyUsd = supply * price;
        borrow = currentToken.totalBorrowsMantissa / 10 ** underlyingDecimal;
        totalBorrowsUsd = borrow * price;

        currentToken.totalSupplyUsd = totalSupplyUsd;
        currentToken.totalBorrowsUsd = totalBorrowsUsd;

        totalSupply += totalSupplyUsd;
        totalBorrow += totalBorrowsUsd;
    }

    let topSupplyArray = tvlData.filter(function (x) { return x.totalSupplyUsd > 20000000 });
    const topSupply = topSupplyArray.map((token) => {
        let srcStr = "assets/images/" + token.underlyingSymbol.toLowerCase() + ".png";
        return (
            <li>
                <div><b><img src={srcStr} width="25" height="25" alt='' />{token.underlyingSymbol.toUpperCase()} </b>
                    ${helper_functions.numberWithSpaces(Number(token.totalSupplyUsd).toFixed(0))} (${helper_functions.numberWithSpaces(Number(token.totalBorrowsUsd).toFixed(0))})</div>
            </li>
        );
    });
    supplyChange = (supplyChange*100).toFixed(2);
    borrowChange = (borrowChange*100).toFixed(2);
    let supplyChangeImg = supplyChange > 0 ? 'assets/images/up.png' : 'assets/images/down.png';
    let borrowChangeImg = borrowChange > 0 ? 'assets/images/up.png' : 'assets/images/down.png';

    return (
        <Card>
            <CardBody>
                <CardTitle className="text-center">
                    <h5>TVL</h5>
                </CardTitle>
                <CardText className="text-left">
                    <div><b>Total Supply:</b> ${helper_functions.numberWithSpaces(totalSupply.toFixed(0))} <img src={supplyChangeImg} alt='' />{Math.abs(supplyChange)}%</div>
                    <div><b>Total Borrow:</b> ${helper_functions.numberWithSpaces(totalBorrow.toFixed(0))} <img src={borrowChangeImg} alt='' />{Math.abs(borrowChange)}%</div>
                    <div><b>Available Liquidity:</b> ${helper_functions.numberWithSpaces((totalSupply - totalBorrow).toFixed(0))} </div>
                    <div className="row">
                        <div><b>Top Supply:</b>
                            <ul style={{ listStyleType: "none" }}>
                                {topSupply}
                            </ul>
                        </div>
                    </div>
                </CardText>
            </CardBody>
        </Card>
    );
}

function RenderIncomeCard({ tvlData, vaiBalance, liquidatonIncome }) {
    let totalLendingIncome = 0;
    let res, decim, price;
    for (let currentToken of tvlData) {
        res = currentToken.totalReservesMantissa;
        decim = Math.pow(10, Number(currentToken.underlyingDecimal));
        price = currentToken.tokenPriceCents / 100;
        totalLendingIncome += res * price / decim;
    }

    return (
        <Card style={{ margin: '5px 0 0 0' }}>
            <CardBody>
                <CardTitle className="text-center">
                    <h5>Income</h5>
                </CardTitle>
                <CardText className="text-left">
                    <div><b>Total income:</b> ${helper_functions.numberWithSpaces(totalLendingIncome.toFixed(0))}</div> 
                    <div><b>Liquidation income:</b> ${helper_functions.numberWithSpaces(liquidatonIncome.toFixed(0))}</div>
                    {/* <div><b>VAI repay income:</b> {helper_functions.numberWithSpaces(vaiBalance.toFixed(0))}</div> */}
                </CardText>
            </CardBody>
        </Card>
    );
}

function RenderXVSVaultCard({ dailyEmision, totalStaked }) {
    return (
        <Card style={{ margin: '5px 0 0 0' }}>
            <CardBody>
                <CardTitle className="text-center">
                    <h5>XVS Vault</h5>
                </CardTitle>
                <CardText className="text-left">
                    <div><b>APR:</b> {(dailyEmision / totalStaked * 365 * 100).toFixed(2)}%</div>
                    <div><b>Total staked:</b> {(totalStaked / 1000000).toFixed(3)} M</div>
                    <div><b>Daily emission:</b> {dailyEmision.toFixed(0)}</div>
                </CardText>
            </CardBody>
        </Card>
    );
}

function RenderVIPItem({ vip }) {
    return (
        <Card style={{ border: '#FFFFFF' }}>
            <CardBody>
                <CardTitle className="text-center">
                    <h6>{vip.title}</h6>
                </CardTitle>
                <CardText className="text-left">
                    <div><b>Active until:</b> {helper_functions.timeConverter(vip.eta)}</div>
                    <div><b>Proposal type:</b> {vip.type} </div>
                    <div>
                        <b>**Summary** </b>
                        {helper_functions.getSummary(vip.description)}
                    </div>
                </CardText>
            </CardBody>
        </Card>
    );
}

function RenderVIPCard({ vips }) {

    const lastVIPs = vips.map((vip) => {
        return (
            <RenderVIPItem vip={vip} />
        );
    });

    return (
        <Card>
            <CardBody>
                <CardTitle className="text-center">
                    <h5>Last VIPs</h5>
                </CardTitle>
                <CardText className="text-left">
                    {lastVIPs}
                </CardText>
            </CardBody>
        </Card>
    );
}

function Home() {

    const [vips, setVips] = React.useState(emptyVips);
    const [supplyChange, setSupplyChange] = React.useState(0);
    const [borrowChange, setBorrowChange] = React.useState(0);
    const [liquidatonIncome, setLiquidatonIncome] = React.useState(0);
    const [dailyEmision, setDailyEmision] = React.useState(0);
    const [totalStaked, setTotalStaked] = React.useState(0);
    const [vaiBalance, setVaiBalance] = React.useState(0);
    const [tvlData, setTvlData] = React.useState([]);

    const provider = new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org');
    const web3 = new Web3(provider);

    const DECIMALS = 10 ** 18;
    const DAILY_BLOCKS = 20 * 60 * 24;
    const VAI_START_BALANCE = 81791963988428644108420;
    const tvl_change_period = 12;

    useEffect(() => {
        const init = async () => {
            const tvl_change = await fetch(tvlChangesJSONLocation)
                .then((response) => response.json());

                setSupplyChange((tvl_change[0].total_supply_usd - tvl_change[tvl_change_period-1].total_supply_usd)/tvl_change[0].total_supply_usd);
                setBorrowChange((tvl_change[0].total_borrow_usd - tvl_change[tvl_change_period-1].total_borrow_usd)/tvl_change[0].total_borrow_usd);
                
        };
        init();
    }, []);

    useEffect(() => {
        const init = async () => {
            const tvl = await fetch(venusAPIUrl)
                .then((response) => response.json());
            const lensContract = new web3.eth.Contract(Abi.lensAbi_balances, chainAddreses.balancesLensAddr);
            let curr_liq_income = 0;
            let res = await lensContract.methods.vTokenBalancesAll(allMarkets, chainAddreses.treasury).call();
            for (let token of res) {
                let vToken = token.vToken;
                let result_row = tvl.result.find(obj => {
                    return (obj.address).toUpperCase() == vToken.toUpperCase();
                })
                let delim = 10 ** Number(result_row.underlyingDecimal);               
                let balance = token.balanceOfUnderlying / delim;
                let usdvalue = balance * result_row.tokenPriceCents / 100;
                curr_liq_income += usdvalue;
            }
            setLiquidatonIncome(curr_liq_income);
        };
        init();
    }, []);

    useEffect(() => {
        const init = async () => {
            const vaiContract = new web3.eth.Contract(Abi.lensAbi_vai_contract, chainAddreses.vai_addr);
            let balance = await vaiContract.methods.balanceOf(chainAddreses.treasury).call();
            let vai_balance = (balance - VAI_START_BALANCE) / DECIMALS + 180_000;
            setVaiBalance(vai_balance);
        };
        init();
    }, []);

    useEffect(() => {
        const init = async () => {
            const lensContract = new web3.eth.Contract(Abi.lensAbi_vault_contract, chainAddreses.xvs_vault[0], chainAddreses.xvs_vault[1]);
            let dailyEmision = await lensContract.methods.rewardTokenAmountsPerBlock(chainAddreses.xvs_addr).call() * DAILY_BLOCKS / DECIMALS;
            setDailyEmision(dailyEmision);
        };
        init();
    }, []);

    useEffect(() => {
        const init = async () => {
            const lensContract = new web3.eth.Contract(Abi.lensAbi_xvs_contract, chainAddreses.xvs_addr);
            let totalStaked = await lensContract.methods.balanceOf(chainAddreses.xvs_vault[0]).call() / DECIMALS;
            setTotalStaked(totalStaked);
        };
        init();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const tvl = await fetch(venusAPIUrl)
                .then((response) => response.json());

            setTvlData(tvl.result);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const vips = await fetch(vipsJSONLocation)
                .then((response) => response.json());

            setVips(vips.slice(Math.max(vips.length - 2, 0)).reverse());
        };

        fetchData();
    }, []);

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-md-6" style={{ padding: '10px 15px 10px 15px' }}>
                    <RenderTVLCard tvlData={tvlData} supplyChange = {supplyChange} borrowChange = {borrowChange}/>
                    <RenderIncomeCard tvlData={tvlData} vaiBalance={vaiBalance} liquidatonIncome={liquidatonIncome} />
                    <RenderXVSVaultCard dailyEmision={dailyEmision} totalStaked={totalStaked} />
                </div>
                <div className="col-6 d-none d-lg-block" style={{ padding: '10px 15px 10px 15px' }}>
                    <RenderVIPCard vips={vips} />
                </div>
            </div>
        </div>
    );
}

export default Home;